import { gql } from 'apollo-angular';
import { dashboardItemFragment } from '../dashboard/dashboard.fragments';

export const dashboardFormatsQuery = gql`
  query DashboardFormatsQuery {
    dashboardFormats {
      nodes {
        id
        title

        dashboards {
          nodes {
            id
          }
        }
      }
    }
  }
`;

export const dashboardFormatWithDashboardsAndWorkspacesQuery = gql`
  query DashboardFormatWithDashboardsAndWorkspaces($id: ID!) {
    node(id: $id) {
      ... on DashboardFormat {
        id
        title

        dashboards {
          nodes {
            ...DashboardItemFragment

            title
            description
            useAlternativeTitle

            workspaces {
              nodes {
                id
              }
            }
          }
        }
      }
    }
  }

  ${dashboardItemFragment}
`;
